import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AmountComponent } from './components/amount/amount.component';
import { TokenizedCardComponent } from './components/tokenized-card/tokenized-card.component';
import { MatMenuModule } from '@angular/material/menu';
import { FieldValidationsListDirective } from './directives/field-validations/field-validations-list.directive';
import { PasswordDirective } from './directives/password-directive/password.directive';
import { ComponentsModule } from '@migo-apps/components';

@NgModule({
  imports: [CommonModule, MatMenuModule, ComponentsModule],
  declarations: [
    AmountComponent,
    TokenizedCardComponent,
    FieldValidationsListDirective,
    PasswordDirective,
  ],
  exports: [
    AmountComponent,
    FieldValidationsListDirective,
    TokenizedCardComponent,
    PasswordDirective,
  ],
})
export class UiModule {}
